export class SummaryFormatError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'SummaryFormatError'
  }
}
